import { render, staticRenderFns } from "./radiobroadcast.vue?vue&type=template&id=05c04000&scoped=true"
import script from "./radiobroadcast.vue?vue&type=script&lang=js"
export * from "./radiobroadcast.vue?vue&type=script&lang=js"
import style0 from "./radiobroadcast.vue?vue&type=style&index=0&id=05c04000&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c04000",
  null
  
)

export default component.exports